<app-charge-widget
	[widgetIcon]="categoryCharges?.image"
	[widgetTitle]="categoryCharges?.label"
	[charges]="charges"
	[subscriptionsAbsence]="subscriptionsAbsence"
	(addSubscriptionClick)="onAddSubscriptionClick()"
	(tabSearchActivate)="onTabSearchActivate()"
	(tabSubscriptionActivate)="onTabSubscriptionActivate()"
>
	<div class="widget-field-wrapper">
		<p class="widget-field-wrapper__title">Поиск начислений по реквизитам</p>
		<div class="widget-field-wrapper__custom-dropdown-wrapper">
			<app-field-builder-dynamic
				[customFormControl]="searchForm.getControlFromAllLevels('typeSelect')!"
			></app-field-builder-dynamic>
		</div>
		<div class="widget-field-wrapper__search-wrapper">
			<app-field-builder-dynamic
				[customFormControl]="searchForm.getControlFromAllLevels('searchText')!"
				(keydown)="handleKeyDown($event)"
			></app-field-builder-dynamic>
			<button
				class="button-reset widget-field-wrapper__search-button"
				(click)="search()"
				[disabled]="
					searchForm.get('searchText')?.invalid || searchForm.get('searchText')?.pristine
				"
				type="button"
			>
				<app-svg-search-magnifying-glass
					width="20px"
					height="20px"
				></app-svg-search-magnifying-glass>
			</button>
		</div>
	</div>
</app-charge-widget>
